module.exports = __webpack_public_path__ + "static/img/4443_phase_function_Paper_PointsHejduk_Prediction.04a78e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4443_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pGjY
// module chunks = 0